import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { DialogType } from '../../domain/enums/dialog-type';
import { DialogProperties } from '../../domain/models/dialog-properties';

@Component({
    selector: 'app-dialog',
    templateUrl: './dialog.component.html',
    styleUrls: ['./dialog.component.scss']
})
export class DialogComponent implements OnInit {
    @Input() selectedDialog: DialogProperties;
    @Input() titleData: any;
    @Input() infoData: any;
    @Output() closeDialog: EventEmitter<string>;

    constructor() {
        this.closeDialog = new EventEmitter<string>();
    }

    ngOnInit(): void {
    }

    public sendCloseDialog(action: string): void {
        this.closeDialog.emit(action);
    }

    public isInformationDialog(): boolean {
        return this.selectedDialog.type === DialogType.InformationDialog;
    }

    public isWarningDialog(): boolean {
        return this.selectedDialog.type === DialogType.WarningDialog;
    }

    public isErrorDialog(): boolean {
        return this.selectedDialog.type === DialogType.ErrorDialog;
    }

    public isConfirmDialog(): boolean {
        return this.selectedDialog.type === DialogType.ConfirmDialog;
    }

    public isLoadingDialog(): boolean {
        return this.selectedDialog.type === DialogType.LoadingDialog;
    }

    public showConfirmButton(): boolean {
        return !this.isLoadingDialog() && !this.isErrorDialog();
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/shared/dialog/dialog.component.ts